/** Recover once per entry bundle, so a missing asset never causes a reload loop. */
export function isChunkLoadError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error);
  return /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS|Loading (?:CSS )?chunk .* failed/i.test(message);
}

export function recoverChunkLoad(error: unknown, storage: Pick<Storage, 'getItem' | 'setItem'>, reload: () => void, bundle = import.meta.url): boolean {
  if (!isChunkLoadError(error)) return false;
  try {
    const key = `stock:chunk-recovery:${bundle}`;
    if (storage.getItem(key)) return false;
    storage.setItem(key, '1');
    reload();
    return true;
  } catch {
    // Without persistent session storage, show the recovery UI instead of looping.
    return false;
  }
}

export function recoverCurrentChunk(error: unknown): boolean {
  try {
    return recoverChunkLoad(error, window.sessionStorage, () => window.location.reload());
  } catch {
    return false;
  }
}
